import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';

export class CopyBlockTemplateModalBloc extends BaseBloc {
  private readonly bloc = resolve(Blocs.course);

  readonly loading = new LoadingState();

  copyBlockTemplate = this.bloc.copyBlockTemplate;
}
